import React, { Fragment, useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import 'react-toastify/dist/ReactToastify.css';
import DataTableExtensions from 'react-data-table-component-extensions';
import placeholder from '../../assets/images/fashion/product/12.jpg';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// import moment from 'moment';
import DeleteConfirmForSelected from '../common/deleteConfirmForSelected';
import { add3Dots } from '../../utils/queryString';
import {
	deleteSelectedAnnouncement,
	getAnnouncement,
} from '../../reducers/adminReducers';
const ListDatatable = ({
	id,
	myData,
	myClass,
	multiSelectOption,
	pagination,
	setActiveId,
	setOpen,
}) => {
	// const [filterText, setFilterText] = useState('');

	const history = useHistory();
	const dispatch = useDispatch();
	const [data, setData] = useState();
	const [selectedBox, setSelectedBox] = useState([]);
	const [openDelPopup, setOpenDelPopup] = useState(false);
	const [selectedRows, setSelectedRows] = useState(true);
	// console.log('data++++', data)
	useEffect(() => {
		setData(myData);
		// console.log('myData=====', myData)
	}, [myData]);
	const columnDefs = [
		{
			name: 'Image',
			cell: (row) => <ProfileImage row={row} />,
		},
		{
			name: 'Title',
			selector: (row) => row.title,
			sortable: true,
		},
		{
			name: 'Description',
			selector: (row) => add3Dots(row.description, 25),
			sortable: true,
		},
		{
			name: 'Date/Time',
			selector: (row) => row.createdAt,
			sortable: true,
		},
		{
			name: 'Action',
			cell: (row) => (
				<ActionButton
					row={row}
					handleDelete={handleDelete}
					handleEdit={handleEdit}
				/>
			),
		},
	];

	const handleEdit = (id) => {
		setActiveId(id);
		history.push(`/create-announcement?id=${id}`);
	};
	const handleDelete = (id) => {
		setActiveId(id);
		setOpen(true);
	};
	const handleSelectCategory = (row) => {
		let selectedPro = [];
		if (!row.allSelected) {
			row?.selectedRows.forEach((el) => {
				selectedPro?.push(el?._id);
			});
			setSelectedBox(selectedPro);
			setSelectedRows(true);
		}
		if (row.allSelected) {
			row?.selectedRows.forEach((el) => {
				selectedPro?.push(el?._id);
			});
			setSelectedBox(selectedPro);
			setSelectedRows(true);
		}
	};
	const handleSelectedDelete = async (e, id) => {
		e.preventDefault();
		// console.log('iddd=====',id)
		const res = await dispatch(deleteSelectedAnnouncement(id));
		const { resultData } = res?.payload;
		// console.log('result data is here in get user data->', resultData);
		if (resultData?.code === 200) {
			dispatch(getAnnouncement());
			setOpenDelPopup(false);
			setSelectedRows(false);
		}
	};
	const onCloseModal = () => {
		setOpenDelPopup(false);
	};
	const selectDeleteOpen = (e) => {
		e.preventDefault();
		if (selectedBox.length > 0) {
			setOpenDelPopup(true);
		}
	};
	return (
		<div>
			<DeleteConfirmForSelected
				open={openDelPopup}
				handleSelectedDelete={handleSelectedDelete}
				onCloseModal={onCloseModal}
				id={selectedBox}
			/>
			<div className="btn-popup pull-right">
				<span className="btn btn-secondary del-btn" onClick={selectDeleteOpen}>
					Delete
				</span>
			</div>
			<Fragment>
				{/* {console.log('DataTableExtensions=====', DataTableExtensions)} */}
				<DataTableExtensions
					columns={columnDefs}
					data={data}
					print={false}
					export={false}
				>
					<DataTable
						data={data}
						columns={columnDefs}
						className={myClass}
						pagination
						striped={true}
						center={true}
						selectableRows
						clearSelectedRows={selectedRows}
						onSelectedRowsChange={(e) => handleSelectCategory(e)}
					/>
				</DataTableExtensions>
			</Fragment>
		</div>
	);
};

// const FilterComponent = ({ filterText }) => (
//   <>
//     <Input
//       id="search"
//       type="text"

//     />
//   </>
// );

// const subHeaderComponent = useMemo(() => {
// return (
//   <FilterComponent
//     onFilter={e => setFilterText(e.target.value)}
//     onClear={handleClear}
//     filterText={filterText}
//   />
// );
// }, [filterText];

const ProfileImage = ({ row }) => {
	return (
		<div className="profile-image">
			<img src={row.image ? row.image : placeholder} alt="logo" />
		</div>
	);
};

const ActionButton = ({ row, handleDelete, handleEdit }) => {
	return (
		<div className="action-btn">
			<span>
				<i
					onClick={() => handleDelete(row._id)}
					className="fa fa-trash"
					style={{
						width: 35,
						fontSize: 20,
						padding: 11,
						color: '#e4566e',
					}}
				></i>
			</span>
			<span>
				<i
					onClick={() => handleEdit(row._id)}
					className="fa fa-pencil"
					style={{
						width: 35,
						fontSize: 20,
						padding: 11,
						color: 'rgb(40, 167, 69)',
					}}
				></i>
			</span>
		</div>
	);
};

export default ListDatatable;
